module.exports = __webpack_public_path__ + "static/media/100-10-1-welcome3.0030cde8.jpg";